import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import sv from './sv';
import en from './en';
import cz from './cz';
import de from './de';
import fr from './fr';
import it from './it';
import no from './no';
import pt from './pt';
import sk from './sk';
import es from './es';
import fi from './fi';
import dk from './dk';
import nl from './nl';
import tr from './tr';

const languages = {sv, en, cz, de, fr, it, no, pt, sk, es, fi, dk, nl, tr};

export default function translate(key) {
    return Component => {
        const mapDispatchToProps = state => {
            return {
                currentLanguage: state.language.currentLanguage
            }
        };

        class TranslationComponent extends React.Component {
            render() {

                let languageTranslations = languages[this.props.currentLanguage];

                if(!languageTranslations){
                    languageTranslations = languages['en'];
                }

                const defaultLanguageTranslations = languages['en'];

                const stringsTranslated = languageTranslations[key];
                const stringsDefaultTranslated = defaultLanguageTranslations[key];

                const merged = {
                    ...this.props.strings,
                    ...stringsDefaultTranslated,
                    ...stringsTranslated,
                };

                return (
                    <Component {...this.props}
                               strings={merged}
                               currentLanguage={this.props.currentLanguage}
                    />
                );
            }
        }

        TranslationComponent.propTypes = {
            strings: PropTypes.object,
            currentLanguage: PropTypes.string
        };

        return connect(mapDispatchToProps)(TranslationComponent);
    };
}


// WEBPACK FOOTER //
// ./src/lib/i18n/translate.js